export let LOADING = 'loading';
export let isLoading = status => status === LOADING;

export let READY = 'ready';
export let isReady = status => status === READY;

export let ERROR = 'error';
export let isError = status => status === ERROR;
